import type {
  NavigationFontStyling,
  NavigationItem,
} from '@susu/headless-commerce/features/navigation/domain'
import classNames from 'classnames'
import { ClientNavLink } from './ClientNavLink'
import styles from './ClientNavLink.module.scss'

export type NavLinkProps = {
  className?: string
  fontStyling?: NavigationFontStyling
  isSubMenu?: boolean
  item: NavigationItem
}

export const NavLink = ({
  className,
  fontStyling = 'regular',
  isSubMenu = false,
  item,
}: NavLinkProps) => {
  const isRenderedInsideSubMenu = isSubMenu

  const listItemClass = classNames(
    {
      [styles['nav__item']]: !isRenderedInsideSubMenu,
      [styles['nav__submenu-item']]: isRenderedInsideSubMenu,
    },
    className,
  )

  return (
    <li className={listItemClass}>
      <ClientNavLink
        item={item}
        fontStyling={fontStyling}
        isSubMenu={isSubMenu}
      />
    </li>
  )
}
